import React, { useState } from "react";
import styles from "./followListItem.module.scss";
import { notification, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { apiRequest } from "util/services";
import { DeleteOutlined, DashboardOutlined, TagOutlined } from "@ant-design/icons";
import { Modal as AntModal } from "antd";
import { useSelector } from "react-redux";
import { resolveApiErrorMessage } from "util/apiErrorMessage";

const FollowListItem = ({ item, fetchList }) => {
  const { t } = useTranslation();
  const theme = useSelector((state) => state.DashboardReducer.theme);
  const [showUnfollowModal, setShowUnfollowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUnfollow = async () => {
    setLoading(true);
    try {
      const result = await apiRequest(
        "topic_tracker/delete",
        "POST",
        { topic_id: item.topic_id },
        true
      );
      if (result?.success || !result?.error) {
        notification.success({
          message: t("followed_topics_page.unfollow_success", "Topic unfollowed successfully"),
        });
        setShowUnfollowModal(false);
        fetchList();
      } else {
        notification.error({
          message: resolveApiErrorMessage(result, t, "followed_topics_page.unfollow_failed"),
        });
      }
    } catch (e) {
      notification.error({
        message: t("followed_topics_page.something_wrong", "Something went wrong"),
      });
    }
    setLoading(false);
  };

  const modalBg = theme === "dark" ? "#1e1e2e" : "#ffffff";
  const modalTextColor = theme === "dark" ? "#e0e0e0" : "#1a1a2e";

  return (
    <>
      <div className={styles.row}>
        <div className={styles.colTopic}>
          <TagOutlined className={styles.topicIcon} />
          <span className={styles.topicName}>{item.topic_name || "—"}</span>
        </div>
        <div className={styles.colDashboard}>
          <DashboardOutlined className={styles.dashIcon} />
          <span className={styles.dashName}>{item.dashboard_name || "—"}</span>
        </div>
        <div className={styles.colActions}>
          <Tooltip title={t("followed_topics_page.unfollow_tooltip", "Unfollow")}>
            <button
              className={styles.unfollowBtn}
              onClick={() => setShowUnfollowModal(true)}
              aria-label={t("followed_topics_page.unfollow", "Unfollow")}
            >
              <DeleteOutlined />
            </button>
          </Tooltip>
        </div>
      </div>

      <AntModal
        open={showUnfollowModal}
        onCancel={() => setShowUnfollowModal(false)}
        footer={null}
        centered
        width={440}
        styles={{
          content: {
            background: modalBg,
            borderRadius: "14px",
            border: "1px solid var(--line)",
            padding: "28px",
          },
        }}
      >
        <div style={{ color: modalTextColor }}>
          <h3 style={{ margin: "0 0 8px", fontSize: "16px", fontWeight: 600, color: modalTextColor }}>
            {t("followed_topics_page.unfollow_topic", "Unfollow Topic")}
          </h3>
          <p style={{ margin: "0 0 20px", fontSize: "13px", color: "var(--fade)", lineHeight: 1.6 }}>
            {t("followed_topics_page.unfollow_confirm_body", {
              topic: item.topic_name,
              defaultValue:
                "You will no longer receive daily notifications for {{topic}}. You can re-follow it anytime from the Topic Library.",
            })}
          </p>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button
              onClick={() => setShowUnfollowModal(false)}
              style={{
                padding: "8px 18px",
                background: "transparent",
                border: "1px solid var(--line)",
                borderRadius: "8px",
                color: modalTextColor,
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              {t("common.cancel", "Cancel")}
            </button>
            <button
              onClick={handleUnfollow}
              disabled={loading}
              style={{
                padding: "8px 18px",
                background: "#ef4444",
                border: "none",
                borderRadius: "8px",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer",
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading
                ? t("followed_topics_page.unfollowing", "Unfollowing...")
                : t("followed_topics_page.unfollow", "Unfollow")}
            </button>
          </div>
        </div>
      </AntModal>
    </>
  );
};

export default FollowListItem;
